// extracted by mini-css-extract-plugin
export default {"displaySec":"calander_displaySec__Mxx5U","textSec":"calander_textSec__C8ttr"};